import React from "react";
import { MediaPreviewContainer, MediaPreviewName } from "./index.styled";

interface MediaPreviewProps {
  file?: File | null;
  videoUrl?: string;
  mediaUrl?: string;
}

const MediaPreview: React.FC<MediaPreviewProps> = ({
  file,
  videoUrl,
  mediaUrl,
}) => {
  // If we have a file, use it (for new uploads)
  if (file) {
    const isVideo = file.type.startsWith("video/");
    const fileUrl = URL.createObjectURL(file);

    // Check if filename contains Hebrew letters
    const hasHebrewLetters = /[\u0590-\u05FF]/.test(file.name);
    const textDirection = hasHebrewLetters ? "rtl" : "ltr";

    return (
      <>
        <MediaPreviewContainer>
          {isVideo ? (
            <video controls>
              <source src={fileUrl} type={file.type} />
              הדפדפן שלך לא תומך בתצוגת סרטונים.
            </video>
          ) : (
            <img src={fileUrl} alt="Uploaded" />
          )}
        </MediaPreviewContainer>
        <MediaPreviewName dir={textDirection}>{file.name}</MediaPreviewName>
      </>
    );
  }

  // Use mediaUrl if provided (for existing media from status), otherwise fall back to videoUrl
  const url = mediaUrl || videoUrl;

  // If we have a media URL from Redux status, display it
  if (url) {
    // Check for data URLs (base64)
    const isDataImage = url.startsWith("data:image/");
    const isDataVideo = url.startsWith("data:video/");

    // Check for file extensions (remove query parameters first)
    const urlWithoutQuery = url.split("?")[0].toLowerCase();
    const isImage =
      isDataImage ||
      /\.(jpg|jpeg|png|gif|webp|bmp|svg|ico)$/i.test(urlWithoutQuery);
    const isVideo =
      isDataVideo ||
      /\.(mp4|webm|ogg|mov|avi|wmv|flv|mkv|m4v)$/i.test(urlWithoutQuery);

    // Default to image if we can't determine (since we're checking image first)
    const displayAsVideo = isVideo && !isImage;

    return (
      <>
        <MediaPreviewContainer>
          {displayAsVideo ? (
            <video controls>
              <source src={url} type="video/mp4" />
              הדפדפן שלך לא תומך בתצוגת סרטונים.
            </video>
          ) : (
            <img src={url} alt="Uploaded media" />
          )}
        </MediaPreviewContainer>
        <MediaPreviewName dir="ltr">
          {url.split("/").pop() || "Media"}
        </MediaPreviewName>
      </>
    );
  }

  return null;
};

export default MediaPreview;
